import {
  SET_FINANCIAL_DATA,
  SET_FINANCIAL_DATA_SIMPLIFIED,
  SET_PROFILE,
  SET_PROFILE_KEY,
  UNSET_PROFILE,
} from '@/vuex/modules/profile/types/mutations';

import {
  CLEAR_PROFILE,
  DEFINE_PROFILE,
  DEFINE_PROFILE_ADDRESS,
  DEFINE_PROFILE_AGREEMENT,
  DEFINE_PROFILE_APPLICATION,
  DEFINE_PROFILE_CONTACT,
  DEFINE_PROFILE_DECLARATIONS,
  DEFINE_PROFILE_DEMOGRAPHICS,
  DEFINE_PROFILE_EMPLOYMENT,
  DEFINE_PROFILE_REAL_ESTATE_EXPERIENCE,
  DEFINE_PROFILE_REAL_ESTATE_OPERATION,
  DEFINE_PROFILE_SOCIAL,
  UPDATE_ASSETS,
  UPDATE_FINANCES,
  UPDATE_INCOME,
  UPDATE_LIABILITIES,
} from '@/vuex/modules/profile/types/actions';

import INCOME_KEYS from '@/vuex/modules/profile/resources/finances/incomeKeys';
import ASSET_KEYS from '@/vuex/modules/profile/resources/finances/assetKeys';
import LIABILITY_KEYS from '@/vuex/modules/profile/resources/finances/liabilityKeys';
import FINANCES_KEYS from '@/vuex/modules/profile/resources/finances/financesKeys';

export default {
  state: {
    profile: null,
  },
  getters: {
    profile: state => state.profile,
  },
  mutations: {
    [SET_PROFILE](state, profile) {
      state.profile = profile;
      localStorage.profile = JSON.stringify(profile);
    },
    [UNSET_PROFILE](state) {
      state.profile = null;
      localStorage.removeItem('profile');
    },
    [SET_PROFILE_KEY](state, payload) {
      const profile = state.profile;
      const value = payload[payload.key];

      profile[payload.key] = value;
      const emptyArray = item => Array.isArray(item) && item.length === 0;
      const emptyObject = item =>
        typeof item === 'object' && Object.keys(item).length === 0;

      profile.missing[payload.key] =
        value === null ||
        value === undefined ||
        emptyObject(value) ||
        emptyArray(value);

      state.profile = profile;
      localStorage.profile = JSON.stringify(profile);
    },
    [SET_FINANCIAL_DATA](state, payload) {
      const profile = state.profile;
      const allowedKeys = payload.allowed;
      const attr = payload.key;
      const data = payload.data;

      Object.keys(data).forEach((key) => {
        if (allowedKeys.includes(key)) {
          profile.finances[attr][key] = data[key];
        }
      });

      state.profile = profile;
      localStorage.profile = JSON.stringify(profile);
    },
    [SET_FINANCIAL_DATA_SIMPLIFIED](state, payload) {
      const profile = state.profile;
      const allowedKeys = payload.allowed;
      const data = payload.data;

      Object.keys(data).forEach((key) => {
        if (allowedKeys.includes(key)) {
          profile.finances[key] = data[key];
        }
      });

      state.profile = profile;
      localStorage.profile = JSON.stringify(profile);
    },
  },
  actions: {
    [CLEAR_PROFILE](context) {
      context.commit(UNSET_PROFILE);
    },
    [DEFINE_PROFILE](context, payload) {
      context.commit(SET_PROFILE, payload.profile);
    },
    [DEFINE_PROFILE_SOCIAL](context, payload) {
      const data = { key: 'social', social: payload.social };
      context.commit(SET_PROFILE_KEY, data);
    },
    [DEFINE_PROFILE_ADDRESS](context, payload) {
      const data = { key: 'address', address: payload.address };
      context.commit(SET_PROFILE_KEY, data);
    },
    [DEFINE_PROFILE_CONTACT](context, payload) {
      const data = { key: 'contact', contact: payload.contact };
      context.commit(SET_PROFILE_KEY, data);
    },
    [DEFINE_PROFILE_DECLARATIONS](context, payload) {
      const data = { key: 'declarations', declarations: payload.declarations };
      context.commit(SET_PROFILE_KEY, data);
    },
    [DEFINE_PROFILE_EMPLOYMENT](context, payload) {
      const data = { key: 'employment', employment: payload.employment };
      context.commit(SET_PROFILE_KEY, data);
    },
    [DEFINE_PROFILE_DEMOGRAPHICS](context, payload) {
      const data = { key: 'demographics', demographics: payload.demographics };
      context.commit(SET_PROFILE_KEY, data);
    },
    [DEFINE_PROFILE_REAL_ESTATE_EXPERIENCE](context, payload) {
      const data = {
        key: 'realEstateExperience',
        realEstateExperience: payload.realEstateExperience,
      };
      context.commit(SET_PROFILE_KEY, data);
    },
    [DEFINE_PROFILE_REAL_ESTATE_OPERATION](context, payload) {
      const data = {
        key: 'realEstateOperation',
        realEstateOperation: payload.realEstateOperation,
      };
      context.commit(SET_PROFILE_KEY, data);
    },
    [DEFINE_PROFILE_APPLICATION](context, payload) {
      const data = { key: 'application', application: payload.application };
      context.commit(SET_PROFILE_KEY, data);
    },
    [DEFINE_PROFILE_AGREEMENT](context, payload) {
      const data = { key: 'agreement', agreement: payload.agreement };
      context.commit(SET_PROFILE_KEY, data);
    },
    [UPDATE_INCOME](context, payload) {
      const data = { allowed: INCOME_KEYS, data: payload, key: 'income' };
      context.commit(SET_FINANCIAL_DATA, data);
    },
    [UPDATE_ASSETS](context, payload) {
      const data = { allowed: ASSET_KEYS, data: payload, key: 'assets' };
      context.commit(SET_FINANCIAL_DATA, data);
    },
    [UPDATE_LIABILITIES](context, payload) {
      const data = {
        allowed: LIABILITY_KEYS,
        data: payload,
        key: 'liabilities',
      };
      context.commit(SET_FINANCIAL_DATA, data);
    },
    [UPDATE_FINANCES](context, payload) {
      const data = { allowed: FINANCES_KEYS, data: payload };
      context.commit(SET_FINANCIAL_DATA_SIMPLIFIED, data);
    },
  },
};



// WEBPACK FOOTER //
// ./src/vuex/modules/profile/index.js